<template>
  <div class="EditingOrderProposalBanner type-xs px-12 desk:px-24 pt-12 desk:pt-24">
    <div class="flex justify-between items-center bg-bg-attention">
      <div
        v-if="orderProposalId"
        class="flex flex-row flex-wrap gap-8 justify-between w-full p-12 items-center"
      >
        <div class="items-center gap-6 flex type-headline-sm">
          <img
            src="/icons/info.svg"
            class="w-16 h-16"
            alt=""
          >
          {{ $t('siteNotice.editingOrderProposal') }} #{{ orderProposalId }}
        </div>
        <img
          src="/icons/close.svg"
          class="w-16 h-16 cursor-pointer"
          :alt="$t('checkout.orderProposal.cancel')"
          @click="emit('clearSales')"
        >
      </div>
      <div v-else class="flex ml-12 gap-8">
        {{ $t('siteNotice.editingOrderProposalCustomer') }}  | <span
          class="underline cursor-pointer"
          @click="emit('clearCustomer')"
        >{{ $t('checkout.orderProposal.cancel') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['clear']);

defineProps<{
  orderProposalId?: number | null;
}>();

</script>
